import React from "react";
import NavBar from "../navbar/NavBar";
import Footer from "../footer/Footer";

const PublicRouteLayout = ({ children }) => {
  return (
    <>
      <NavBar />
      {children}
      <Footer />
    </>
  );
};

export default PublicRouteLayout;
